export default "/assets/images/home-wrecker4.a50613737200eb52.png";